export class Paths {
  static home = () => '/'
  static gallery = () => '/gallery'
  static colors = () => '/colors'
  static check = () => '/check'
  static solve = () => '/solve'
  static privacy = () => '/privacy'
  static terms = () => '/terms'
}